<template>
    <div style="width: 100%; height: 100%;">
        <swb-query-sort-area name="query_model_ctrl" ref="query_model_ctrl" class="mb10" :forHisQry="forHisQry" :config="queryConfigX" :queryHandler="queryHandler" :mountedHandler="mountedHandler"></swb-query-sort-area>
        <swb-result-table name="result_table" ref="result_table" :forHisQry="forHisQry" :config="resultConfigX" :needPager="needPager" :rowNoShow="rowNoShow" :rowNoFixed="rowNoFixed" :height="theTableHeight"
                          :pageNoChangeHandler="pageNoChangeHandler"></swb-result-table>
    </div>
</template>
<script>
    import {Utilsx, $, Jqext} from '../../app.base'
    import {Vue, MsgBox, DomSizeWatcher} from '../../app.vues'

    let Toast = Jqext.Toast;

    import {getDefaultPageSizes} from '../../app.conf'

    import SwbQuerySortArea from '../query/QuerySortArea.vue'
    import SwbResultTable from '../query/ResultTable.vue'

    Vue.regist(SwbQuerySortArea);
    Vue.regist(SwbResultTable);

    export default {
        name: 'swb-his-records-view',
        props: {
            //查询表名
            queryTable: {
                type: String
            },
            //查询配置
            queryConfig: {
                type: Object
            },
            //结果配置
            resultConfig: {
                type: Object
            },
            //排除的上下文名称
            excludedCtxNames: {
                type: Array,
                default: null
            },
            //获取结果的函数
            //(requestData, callback(result))
            resultFetcher: {
                type: Function
            }
        },
        data: function () {
            return {
                forHisQry: true,
                //
                needPager: true,
                rowNoShow: true,
                rowNoFixed: true,
                btnColName: null,
                //
                theTableHeight: 600,
                //
                queryConfigX: {
                    queryFields: [],
                    sortFields: []
                },
                resultConfigX: {
                    colList: []
                },
                //请求/结果模型
                queryModel: {},
                resultModel: {}
            }
        },
        watch: {
            queryConfig(newVal, oldVal) {
                this.refreshConfig();
            },
            resultConfig(newVal, oldVal) {
                this.refreshConfig();
            }
        },
        mounted() {
            let self = this;
            //注册domSizeWatcher
            let thisEl = $(this.$el);
            //
            let domSizeWatcher = this.domSizeWatcher = new DomSizeWatcher('his-records-view');
            domSizeWatcher.setBaseEl(thisEl);
            domSizeWatcher.setMainEl(thisEl.find('[name="result_table"]'), function (width, height, theEl) {
                //根据新主元素的内容大小，调整表格高度
                self.theTableHeight = height;
            });
            //domSizeWatcher.setHrEls();
            domSizeWatcher.setVtEls(thisEl.find('[name="query_model_ctrl"]'));
            domSizeWatcher.start(500);
            //------------------------------------------------------------------
            let query_model_ctrl = this.$refs['query_model_ctrl'];
            let resultTable = this.$refs['result_table'];
            //关联[查询排序对象]到结果表格（结果表格可以实时利用最新的 列配置 和 排序信息，同时结果表格列宽也会反向同步到其中的[列配置对象]中去）
            resultTable.setQrySortRef(query_model_ctrl);
            //
            console.log('mounted');
            //
            this.refreshConfig();
        },
        beforeDestroy() {
            //释放domSizeWatcher
            let domSizeWatcher = this.domSizeWatcher;
            if (domSizeWatcher != null) {
                domSizeWatcher.clear();
                this.domSizeWatcher = null;
            }
        },
        methods: {
            refreshConfig() {
                if (this.queryTable) {
                    console.log(this.queryTable);
                }
                if (this.queryConfig) {
                    console.log(this.queryConfig);
                }
                if (this.resultConfig) {
                    console.log(this.resultConfig);
                }
                //------------------------------------------------------------------
                let queryConfig = this.queryConfig || {};
                let queryConfigX = {
                    queryFields: queryConfig.queryFields || [],
                    sortFields: queryConfig.sortFields || []
                };
                this.queryConfigX = queryConfigX;

                let resultConfig = this.resultConfig || {};
                let resultConfigX = {
                    colList: resultConfig.colList || []
                };
                this.resultConfigX = resultConfigX;

                //
                let resultTable = this.$refs['result_table'];
                resultTable.initMeta([]);
            },
            fetchResult(requestData) {
                requestData.tableName = this.queryTable;
                console.log(requestData);
                //按需排除上下文名称
                let excludedCtxNames = this.excludedCtxNames || [];
                if (excludedCtxNames.length > 0) {
                    let condCtxMapping = requestData.condCtxMapping || {};
                    for (let colName in condCtxMapping) {
                        let ctxBindName = condCtxMapping[colName];
                        if (ctxBindName && excludedCtxNames.indexOf(ctxBindName) != -1) {
                            delete condCtxMapping[colName];
                            console.log('已从上下文去除：' + ctxBindName);
                        }
                    }
                    requestData.condCtxMapping = condCtxMapping;
                }
                //
                if (typeof this.resultFetcher == 'function') {
                    //TODO 请求结果
                    let self = this;
                    this.resultFetcher(requestData, function (result) {
                        if (result.success) {
                            let resultData = result.data || {};
                            let dataRows = resultData.rows || [];
                            let pagination = resultData.pagination;
                            self.renderTable(dataRows, pagination);
                        } else {
                            let errMsg = '查询结果失败：' + result.message + ' !';
                            Toast.show(errMsg, 10000, 'error');
                            console.error(errMsg);
                        }
                    });
                } else {
                    let errMsg = '未指定 resultFetcher !';
                    Toast.show(errMsg, 10000, 'error');
                    console.error(errMsg);
                }
            },
            mountedHandler(queryModelCtrl) {
                console.log('sortarea mounted');
            },
            queryHandler(queryModel) {
                //console.log(queryModel);
                this.queryModel = queryModel;
                //
                let resultTable = this.$refs['result_table'];
                let resultModel = resultTable.getResultInfo(true);
                resultModel.pageNumber = 1; //从第一页查询
                //console.log(resultModel);
                this.resultModel = resultModel;
                //
                let requestData = Utils.merge({}, this.queryModel);
                requestData = Utils.merge(requestData, this.resultModel);
                //
                this.fetchResult(requestData);
            },
            pageNoChangeHandler(pageNumber, pageSize) {
                console.log('分页变化：pageNumber ' + pageNumber + " , pageSize " + pageSize);
                let resultTable = this.$refs['result_table'];
                let resultModel = resultTable.getResultInfo(true);
                // console.log(resultModel);
                this.resultModel = resultModel;
                //
                let requestData = Utils.merge({}, this.queryModel);
                requestData = Utils.merge(requestData, this.resultModel);
                //
                this.fetchResult(requestData);
            },
            renderTable(rows, pagination) {
                let resultTable = this.$refs['result_table'];
                let tableData = {
                    rows: rows,
                    pagination: pagination
                };
                resultTable.render(tableData);
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/comn/HisRecordsView.vue